import { useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  editId,
  editIdPlanoGetnet,
  editQtdeDependentes,
  editTitulo,
  editValor,
} from "../../actions/PlanosEscolhidoActions";

const CardPlano = ({
  tituloComposicao,
  valorComposicao,
  idComposicao,
  idPlanoGetnet,
  qtdeDependentes,
  editId,
  editIdPlanoGetnet,
  editTitulo,
  editValor,
  editQtdeDependentes,
}) => {
  const [redirect, setRedirect] = useState(false);
  const history = useHistory();

  const handleClickAssinar = (
    e,
    id,
    titulo,
    valor,
    planoIdGetnet,
    qtdeDependente
  ) => {
    e.preventDefault();
    /**
     * SALAVAR DADOS DO PLANO ESCOLHIDO NO REDUX
     */
    editId(id);
    editTitulo(titulo);
    editValor(valor);
    editIdPlanoGetnet(planoIdGetnet);
    editQtdeDependentes(qtdeDependente);

    setRedirect(true);
  };

  if (redirect) {
    history.push("/cadastro");
  }

  return (
    <div className="card card-plano-select bg-light mb-3">
      <div className="card-header bg-light-blue">{tituloComposicao}</div>
      <div className="card-body">
        <img
          src={`${
            process.env.REACT_APP_PUBLIC_URL
          }imagens/icones-box-planos/icon-user-${qtdeDependentes + 1}.svg`}
          alt={`Plano ${tituloComposicao}`}
          className="img-fluid mb-3 icone-box-plano"
        />
        <p className="card-text">
          <span className="cifrao">R$</span> {valorComposicao}
        </p>
        <button
          onClick={(e) =>
            handleClickAssinar(
              e,
              idComposicao,
              tituloComposicao,
              valorComposicao,
              idPlanoGetnet,
              qtdeDependentes
            )
          }
          className="btn bg-red color-white"
        >
          Assinar
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, {
  editValor,
  editTitulo,
  editId,
  editIdPlanoGetnet,
  editQtdeDependentes,
})(CardPlano);
